import React from "react";
import {
  getLabel,
  getLabelTag,
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
  getLabelTagYesNO,
} from "../../InspectionSummaries/constructTextFromValues";
import {
  nutritionalRatingOptions,
  nutritionalRiskType,
  nutritionRiskFactorsOptions,
} from "../../Options/clinicalEvaluationOptions";
import { Image, Space } from "antd";
import SummaryWrapper from "../../InspectionSummaries/SummaryWrapper";
import { yesNoOptions } from "../../Options/commonOptions";
import {
  dietOptions,
  entrealDietOptions,
  liquidDietOptions,
  oralDietOptions,
  otherSpecificationsOptions,
  parentalTypeOptions,
  rootFeedOptions,
} from "../../Options/dietAdviceOptions";
import riskAssessmentIcon from "../../../../assets/doctorIcons/riskAssessment.svg";

const NutritionistRiskAssessmentSummary = ({ formData }) => {
  const constructRiskSummaryItems = () => {
    const riskSummaryItems = [];
    const functional_diagnosis = formData?.functional_diagnosis || {};
    const pushRiskAssessmentItem = (key, label, children) => {
      riskSummaryItems.push({ key, label, children });
    };

    if (functional_diagnosis?.nutritional_status) {
      pushRiskAssessmentItem(
        "1",
        "Nutritional Status",
        <>
          {getLabelTag(
            nutritionalRatingOptions,
            functional_diagnosis?.nutritional_status
          )}
        </>
      );
    }

    if (functional_diagnosis?.bmi) {
      pushRiskAssessmentItem(
        "2",
        "BMI",
        <>
          {/* {getLabelTagInput("Height", functional_diagnosis?.bmi?.height)}
          {getLabelTagInput("Weight", functional_diagnosis?.bmi?.weight)} */}
          {getLabelTagInput(
            "BMI",
            functional_diagnosis?.bmi?.bmi_value,
            "kg/m2"
          )}
          {getLabelTagInput(
            "Interpretation",
            functional_diagnosis?.bmi?.interpretation
          )}
          {getLabelTagInput(
            "Height(ft/in)",
            getLabel(
              `${functional_diagnosis?.bmi?.height_feet}ft ${functional_diagnosis?.bmi?.height_inches}inches`
            )
          )}
          {getLabelTagInput(
            "Height(cm)",
            getLabel(`${functional_diagnosis?.bmi?.height_in_cm} cm`)
          )}
          {getLabelTagInput("Weight", functional_diagnosis?.bmi?.weight, "kgs")}
        </>
      );
    }
    if (functional_diagnosis?.nutrition_risk_factor_details?.risk_factors) {
      pushRiskAssessmentItem(
        "3",
        "Nutrition Risk Factors",
        <>
          {getLabelTagsArray(
            nutritionRiskFactorsOptions,
            functional_diagnosis?.nutrition_risk_factor_details?.risk_factors
          )}
          {getLabelTagInput(
            "Other Details",
            functional_diagnosis?.nutrition_risk_factor_details
              ?.others_description
          )}
        </>
      );
    }
    if (functional_diagnosis?.nutritional_risk_details?.risk) {
      pushRiskAssessmentItem(
        "4",
        "Nutritional Risk",
        <>
          {getLabelTagYesNO(
            functional_diagnosis?.nutritional_risk_details?.risk
          )}
          {getLabelTag(
            nutritionalRiskType,
            functional_diagnosis?.nutritional_risk_details?.risk_type
          )}
          {getLabelTagInput(
            "Reason for Risk",
            functional_diagnosis?.nutritional_risk_details?.risk_description
          )}
        </>
      );
    }
    if (
      functional_diagnosis?.nutritional_recommendations?.calories ||
      functional_diagnosis?.nutritional_recommendations?.protein ||
      functional_diagnosis?.nutritional_recommendations?.carbohydrates ||
      functional_diagnosis?.nutritional_recommendations?.sodium ||
      functional_diagnosis?.nutritional_recommendations?.potassium
    ) {
      pushRiskAssessmentItem(
        "5",
        "Nutritional Recommendations",
        <>
          {getLabelTagInput(
            "Energy",
            functional_diagnosis?.nutritional_recommendations?.calories,
            "Kcal/day"
          )}
          {getLabelTagInput(
            "Protein",
            functional_diagnosis?.nutritional_recommendations?.protein,
            "gms/day"
          )}
          {getLabelTagInput(
            "Carbohydrates",
            functional_diagnosis?.nutritional_recommendations?.carbohydrates,
            "gms/day"
          )}
          {getLabelTagInput(
            "Sodium",
            functional_diagnosis?.nutritional_recommendations?.sodium,
            "mg/day"
          )}
          {getLabelTagInput(
            "Potassium",
            functional_diagnosis?.nutritional_recommendations?.potassium,
            "mg/day"
          )}
        </>
      );
    }
    if (functional_diagnosis?.diet_details?.diet) {
      pushRiskAssessmentItem(
        "6",
        "Type of Diet",
        <>
          {getLabelTag(dietOptions, functional_diagnosis?.diet_details?.diet)}
          {getLabelTag(
            oralDietOptions,
            functional_diagnosis?.diet_details?.type_of_diet
          )}
          {getLabelTag(
            liquidDietOptions,
            functional_diagnosis?.diet_details?.type_of_liquid_diet
          )}
          {getLabelTag(
            entrealDietOptions,
            functional_diagnosis?.diet_details?.type_of_diet
          )}
          {/* {getLabelTag(
            oralDietTypeOptions,
            functional_diagnosis?.diet_details?.type_of_oral_diet
          )} */}
          {/* {getLabelTag(
            entrealFeedTypeOptions,
            functional_diagnosis?.diet_details?.type_of_enteral_feed
          )} */}
          {getLabelTag(
            rootFeedOptions,
            functional_diagnosis?.diet_details?.root_of_enteral_feed
          )}
          {getLabelTag(
            parentalTypeOptions,
            functional_diagnosis?.diet_details?.type_of_parenteral_diet
          )}
          {getLabelTagInput(
            "Central Line",
            functional_diagnosis?.diet_details?.parental_central_line
          )}
          {getLabelTagInput(
            "Peripheral Line",
            functional_diagnosis?.diet_details?.parental_peripheral_line
          )}
        </>
      );
    }
    if (
      getLabelTagsWithDescription(
        otherSpecificationsOptions,
        functional_diagnosis?.other_specifications
      )
    ) {
      pushRiskAssessmentItem(
        "7",
        "Other Specifications",
        <>
          {getLabelTagsWithDescription(
            otherSpecificationsOptions,
            functional_diagnosis?.other_specifications
          )}
          {getLabelTagsWithDynamicInputs(
            functional_diagnosis?.other_specifications?.others
          )}
        </>
      );
    }
    if (functional_diagnosis?.patient_family_education) {
      pushRiskAssessmentItem(
        "8",
        "Patient Family Education",
        getLabelTag(
          yesNoOptions,
          functional_diagnosis?.patient_family_education
        )
      );
    }
    return riskSummaryItems;
  };
  const riskSummaryItems = constructRiskSummaryItems();
  return (
    <>
      {riskSummaryItems.length > 0 && (
        <SummaryWrapper
          items={riskSummaryItems}
          title={
            <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
              <Space>
                <Image src={riskAssessmentIcon} width={18} preview={false} />
                <span style={{ fontSize: "16px", fontWeight: "normal" }}>
                  Risk Assessment
                </span>
              </Space>
            </span>
          }
        />
      )}
    </>
  );
};

export default NutritionistRiskAssessmentSummary;
